import { Dashboard } from '../../common/components/dashboards/types';
import { Filter } from '../../common/components/filter/filterbar/types';
import { CustomError, GraphQLError } from '../../common/errors';
import { AssignedPermissions, Permission } from '../permission/types';
import { AllowedDomain } from '../types';
import { UserRolePreferencesSettings } from '../userrolepreferences/types';

export enum InitialDependenciesErrors {
  GENERAL_INITIAL_DEPENDENCIES_ERROR = 'GENERAL_INITIAL_DEPENDENCIES_ERROR',
  NETWORK_ERROR = 'NETWORK_ERROR',
  USER_NOT_FOUND_ERROR = 'USER_NOT_FOUND_ERROR',
  WRONG_AUTH_METHOD_ERROR = 'WRONG_AUTH_METHOD_ERROR',
  IP_FORBIDDEN_ERROR = 'IP_FORBIDDEN_ERROR',
}

export class InitialDependenciesError extends CustomError {
  constructor(
    readonly name: InitialDependenciesErrors,
    readonly underlyingError: GraphQLError
  ) {
    const message = `${underlyingError.name}: ${underlyingError.message}`;
    super(name, message);
  }
}

export class InitialDependenciesGeneralError extends InitialDependenciesError {
  constructor(error: GraphQLError) {
    super(InitialDependenciesErrors.GENERAL_INITIAL_DEPENDENCIES_ERROR, error);
  }
}

export class InitialDependenciesNetworkError extends InitialDependenciesError {
  constructor(error: GraphQLError) {
    super(InitialDependenciesErrors.NETWORK_ERROR, error);
  }
}

export class InitialDependenciesUserNotFoundError extends InitialDependenciesError {
  constructor(error: GraphQLError) {
    super(InitialDependenciesErrors.USER_NOT_FOUND_ERROR, error);
  }
}

export class InitialDependenciesWrongAuthMethodError extends InitialDependenciesError {
  constructor(error: GraphQLError) {
    super(InitialDependenciesErrors.WRONG_AUTH_METHOD_ERROR, error);
  }
}

export class InitialDependenciesIpForbiddenError extends InitialDependenciesError {
  constructor(error: GraphQLError) {
    super(InitialDependenciesErrors.IP_FORBIDDEN_ERROR, error);
  }
}

type RoleId = string;
type Email = string;

export interface FrontendStartupRoleDetails {
  preferencesLatestVersion: UserRolePreferencesSettings<Filter> | null;
  allowedDomains: AllowedDomain[];
  allPermissions: AssignedPermissions<Permission>;
}

export interface FrontendStartupCurrentUser {
  email: Email;
  roleId: RoleId; // User role Id (only used for admin permissions/show the admin menu)
  userRole: FrontendStartupRoleDetails | null;
}

export interface FrontendStartupSimulatedRole {
  simulatedRole: FrontendStartupRoleDetails | null;
  listAllDashboards: Dashboard[] | null;
}

export type MaybeFrontendStartupSimulatedRole =
  FrontendStartupSimulatedRole | null;

export type FrontendStartup = {
  currentUser: FrontendStartupCurrentUser | null;
  listAllDashboards: Dashboard[] | null;
};
